<template>

  <b-card > 
    <b-row v-show="showCharts">
        <b-col sm="8">
         <div id="chartdivz" style="height:500px;"></div>
         <!--<apexchart type="bar" height="400" :options="chart.options" :series="chart.series"></apexchart> -->
        </b-col>
        <b-col sm="4">
           <div id="chartdivi" style="height:800px;"></div> 
        </b-col>
      </b-row>
      <b-table v-show="showCharts" striped :items="tableData" :fields="tableHeaders"></b-table>
      <b-row>
        <b-col v-if="request">
          <b-alert variant="warning" :show="true">Caricamento dati nel periodo selezionato</b-alert>
        </b-col>
        <b-col v-else-if="!showCharts">
          <b-alert variant="warning" :show="true">Dati TEP non disponibili nel periodo selezionato</b-alert>
        </b-col>
      </b-row>
  </b-card>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
var moment = require('moment');
/*moment.updateLocale('it', {
  monthsShort: 'Gen_Feb_Mar_Apr_Mag_Giu_Lug_Ago_Set_Ott_Nov_Dic'.split('_')
})*/

export default {
  name: "TepStacked",

  props:['monthFrom', 'monthTo', 'sites'],

  data() {
     return {
      chartOptions: {
        height: 400,
        legend: { position: 'top', maxLines: 3 },
        bar: { groupWidth: '75%' },
        isStacked: true,
        chartArea: {
          width: "90%"
        }
      },
      tableData: [],
      tableHeaders: [],
      chartData: {},
      chartReady: false,
      userReady: false,
      request: false,
      showCharts: false,
      pie: {
        options: {
          // colors: this.$store.state.colors,
          labels: [],
          showTooltipOn: "hit",
          tooltip: {
            y: {
              formatter: (val) => {
                return this.$options.filters.formatDecimal(val)
              },
            },
          },
          legend: {
            position: 'bottom',
            fontSize: "11px",
            formatter: (seriesName, opts) => {
              return seriesName.split(',')[0]
            },
          },
        },
        series: []
      },
      chart: {
        options: {
          colors: this.$store.state.colors,
          dataLabels: {
            enabled: false
          },
          tooltip: {
            y: {
              formatter: (val, o) => {
                return `${this.f(val)} ${this.chart.options.xaxis.categories[o.dataPointIndex]}`
              }
            }
          },
          xaxis: {
          },
          yaxis: {
            axisBorder: {
              show: true,
            },
            axisTicks: {
              show: true,
            },
            title: {
              text: "TEP",
            },
            tooltip: {
              enabled: false
            },
            labels: {
              formatter: x => this.f(x)
            }
          }
        },
        series: []
      },
       colors: this.$store.state.colors,
    }
  },


  computed: {
    customer() {
      return this.$store.state.customers.selected
    },
    selectedMonths() {
      return this.months.map( m => parseInt(m) )
    }
  },

  watch: {
    customer(v) {
      if(v.guid) {
        this.userReady = true
        this.refresh()
      }
    },
    monthFrom(v) {
      this.refresh()
    },
    monthTo(v) {
      this.refresh()
    }
  },

  created() {
    this.userReady = this.$store.state.customers.selected.guid
  },

  mounted() {
    this.refresh();
    this.barChart();
    this.createAmPieChart();
    
  },

  methods: {
   async barChart()
   {
      let chart = am4core.create("chartdivz", am4charts.XYChart);
      chart.language.locale = am4lang_it_IT;
      chart.language.locale["_decimalSeparator"] = ",";
      chart.language.locale["_thousandSeparator"] = "'";
      let params = {
          sitesGuids: this.sites.map( s => s.guid),
          fromMonth: this.monthFrom,
          toMonth: this.monthTo
      }
      const data = await this.$store.dispatch("charts/tep", params);     
      let seriesz = []
          seriesz=data.items.map(item=>
           {
             let obj={'name':item.siteName,'unit':data.mus[0],'value':item.EE.toFixed(2)};
            return obj;
           });

      chart.data=seriesz;

      chart.colors.list = this.colors.map( e => {
          return  am4core.color(e)
        });
  let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
  categoryAxis.dataFields.category = "name";
  categoryAxis.renderer.grid.template.location = 0;
  categoryAxis.renderer.minGridDistance = 30;
  categoryAxis.renderer.labels.template.rotation = -90;
  categoryAxis.renderer.labels.template.fontSize = 11;
  categoryAxis.renderer.labels.template.horizontalCenter = "right";
  categoryAxis.renderer.labels.template.verticalCenter = "middle";
  categoryAxis.tooltip.disabled = true;
  categoryAxis.renderer.minHeight = 110;

  let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
  valueAxis.title.text = "TEP";
  // Create series
  let series = chart.series.push(new am4charts.ColumnSeries());
  series.dataFields.valueY = "value";
  series.dataFields.categoryX = "name";
  series.tooltipText = "{name} [[{unit}]]: [bold] {value}";
  valueAxis.renderer.minWidth = 50;
  series.columns.template.strokeWidth = 0;
  series.tooltip.pointerOrientation = "vertical";
  series.columns.template.column.fillOpacity = 0.8;
  series.sequencedInterpolation = true;
  chart.cursor = new am4charts.XYCursor();
   },   
  async createAmPieChart(){
       let params = {
        sitesGuids: this.sites.map( s => s.guid),
        fromMonth: this.monthFrom,
        toMonth: this.monthTo
      }
      const data = await this.$store.dispatch("charts/tep", params);       
      try{
        let series = []
        series=data.items.map(item=>
        {
          let obj={'name':item.siteName,'unit':data.mus[0],'value':item.EE.toFixed(2)};
          return obj;
        });
        // Create chart instance
        var chart = am4core.create("chartdivi", am4charts.PieChart);
        chart.language.locale = am4lang_it_IT;
        chart.language.locale["_decimalSeparator"] = ",";
        chart.language.locale["_thousandSeparator"] = "'";
        chart.legend = new am4charts.Legend();
        chart.fontSize = 11;
        if(this.reportMode) {
          chart.fontSize = 10;
        }
        // Add data
        chart.data = series
        let colors = this.$store.state.colors;
        var colorSet = new am4core.ColorSet();
        colorSet.list = colors.map(function(color) {
          return new am4core.color(color);
        });
        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.colors = colorSet;
        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;

        // This creates initial animation
        pieSeries.hiddenState.properties.opacity = 1;
        pieSeries.hiddenState.properties.endAngle = -90;
        pieSeries.hiddenState.properties.startAngle = -90;

        pieSeries.ticks.template.disabled = true;
        pieSeries.alignLabels = false;
        pieSeries.labels.template.forceHidden = true;


        // tooltip settings
        pieSeries.slices.template.forceHidden = true;
        pieSeries.labels.template.text = "";
        pieSeries.slices.template.adapter.add("hidden", hideSmall);

        // pieSeries.slices.template.tooltipText = "{name} [[{unit}]]: [bold] {value}";
        chart.hiddenState.properties.radius = am4core.percent(0);
      }catch(error){
        console.log(error)
      }
    },
    onChartReady() {
      this.chartReady = true
      this.refresh()
    },
    async refresh() {
      let params = {
        sitesGuids: this.sites.map( s => s.guid),
        fromMonth: this.monthFrom,
        toMonth: this.monthTo
      }

      this.request = true;
      try {
        const data = await this.$store.dispatch("charts/tep", params);

      // this.$toasted.show('TEP aggiornato', { duration: 3000, icon : 'check', theme: "bubble" })
      this.$notify({
        type: "success",
        text: "TEP aggiornato",
        title: 'Successo'
      }); 
        let skip = true
        data.items.forEach(i => {
          if(i.siteName)
            skip = false
        })

        this.showCharts = !skip
        if(skip)
          return

        this.tableHeaders = [
          { sito: { label: 'Sito', sortable: true, index: 0 } },
          { EE: { label: 'TEP EE', sortable: true, index: 1 } },
          { gas: { label: 'TEP Gas', sortable: true, index: 2 } },
          { TEP: { label: 'TEP', sortable: true, index: 3 } },
          { P:  { label: "%", sortable: true, index: 4 } }
        ]
        let chartHeaders = [ 'Vettore' ]
        data.vectors.forEach( v => {
          chartHeaders.push(v)
          this.tableHeaders.push(v)
        })

        let table = [ chartHeaders ];
        this.tableData = []
        data.items.forEach( (item) => {
          if(item.siteName != null) {

            let row = [ item.siteName ]
            data.vectors.forEach( v => {
              row.push( item[v] )
            })

            table.push(row)

            this.tableData.push({
              sito: item.siteName,
              TEP: item.TEP.toFixed(2),
              P : item.rate.toFixed(2) + "%",
              EE: item.EE.toFixed(2),
              GPL: item.GPL.toFixed(2),
              gas: item.gas.toFixed(2),
              Diesel: item.Diesel.toFixed(2),
            })
          }
        })

        this.chart.options.xaxis.categories = data.items.map( item => item.siteName)
        this.chart.options = _.cloneDeep(this.chart.options)

        this.chart.series = []
        data.vectors.forEach(vector => {
          this.chart.series.push({
            name: vector,
            data: data.items.map( item => item[vector] )
          })
        })

        this.pie.options.labels = data.items.map( item => item.siteName )
        this.pie.options = _.cloneDeep(this.pie.options)
        this.pie.series = data.items.map( item => item.TEP )

        // this.chartData = google.visualization.arrayToDataTable(table)
      } finally {
        this.request = false;
      }
    },
    f(v) {
      return this.$options.filters.formatDecimal(v)
    },
  },
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/TepStacked.vue